<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Project Publish Confirmation</p>
        </header>
        <section class="modal-card-body">
            <!-- Missing Socialtools details -->
            <div v-if="hasIncompleteData">
                <b-message type="is-danger" has-icon icon-size="is-medium">
                    Missing Social Tools detail was detected in some of the project brand columns. Please revise the project and verify them.
                </b-message>
                <b-table
                    :data="incompleteColumns"
                    :pagination-simple="false"
                    :narrowed="true"
                >
                    <template slot-scope="props">
                        <b-table-column field="brandColumn" label="Brand Column">
                            {{ props.row.name }}
                        </b-table-column>
                        <b-table-column field="socialNetworks" label="Social Networks">
                            {{ props.row.socialNetworks.join(', ') }}
                        </b-table-column>
                    </template>
                </b-table>
            </div>
            <!-- InActive social network pages and pages that only have data for less than twelve months-->
            <div v-if="!hasIncompleteData">
                <div class="warning-pannel" v-if="hasInActivePages">
                    <b-message type="is-warning" has-icon icon-size="is-medium">
                        The following social network pages in Socialtools are not active, so no data will be collected for these pages.
                    </b-message>
                    <b-table
                        :data="inActivePagesColumns"
                        :pagination-simple="false"
                        :narrowed="true"
                    >
                        <template slot-scope="props">
                            <b-table-column field="brandColumn" label="Brand Column">
                                {{ props.row.name }}
                            </b-table-column>
                            <b-table-column field="socialNetworkPages" label="Social Network Pages">
                                <span v-for="(page, index) in props.row.socialNetworkPages" v-bind:key="index">
                                    {{ page.name }}
                                    (<i style="font-size: 0.9em">{{page.socialNetwork}}</i>)
                                    <br/>
                                </span>
                            </b-table-column>
                        </template>
                    </b-table>
                    <hr>
                </div>
                <div class="warning-pannel"  v-if="hasPagesWithLessThenTwelveMonthData">
                    <b-message type="is-warning" has-icon icon-size="is-medium">
                        The following social network pages do not have 12 months of historical data in Socialtools.
                    </b-message>
                    <div class="b-table">
                        <table class="table is-narrow has-mobile-cards">
                            <tr>
                                <th>Brand Column</th>
                                <th>Social Network Pages</th>
                                <th>Available From</th>
                            </tr>
                            <template v-for="column in pagesWithLessThenTwelveMonthDataColumns">
                                <tr v-for="(page, index) in column.socialNetworkPages" v-bind:key="page.name">
                                    <td :rowspan="column.socialNetworkPages.length" v-if="index == 0">{{column.name}}</td>
                                    <td>{{ page.name }}</td>
                                    <td>{{ page.startDate | formatDate("dd-MMM-YYYY") }}</td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="warning-pannel"  v-if="!hasPagesWithLessThenTwelveMonthData">
                    <b-message type="is-info" has-icon icon-size="is-medium">
                        Historical data for all
                        {{
                            hasInActivePages
                                ? "active social network pages will be collected for the past 12 months. Inactive pages will be omitted."
                                : "the social network pages will be collected for the past 12 months."
                        }}
                    </b-message>
                </div>
                <div>
                    Would you like to continue with publishing?
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button type="button" class="button" @click="cancel">{{hasIncompleteData ? "OK": "Cancel"}}</button>
            <button type="button" class="button is-primary" @click="confirm" v-if="!hasIncompleteData">Publish</button>
        </footer>
    </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
export default {
    name: 'ProjectPublishConfirmation',
    props: {
        projectColumns: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            incompleteColumns: [],
            inActivePagesColumns: [],
            pagesWithLessThenTwelveMonthDataColumns: []
        };
    },
    created () {
        let validatedObj = validateSocialToolsDetails(this.projectColumns);
        this.incompleteColumns = validatedObj.incompleteColumns;
        this.inActivePagesColumns = validatedObj.inActivePagesColumns;
        this.pagesWithLessThenTwelveMonthDataColumns = _.sortBy(validatedObj.pagesWithLessThenTwelveMonthDataColumns, (d) => d.dataAvailableFrom).reverse();
        if (this.pagesWithLessThenTwelveMonthDataColumns && this.pagesWithLessThenTwelveMonthDataColumns.length > 0) {
            this.dataAvailableFrom = this.pagesWithLessThenTwelveMonthDataColumns[0].dataAvailableFrom;
        }
    },
    methods: {
        confirm () {
            this.$emit('confirmPublish');
            this.$parent.close();
        },
        cancel () {
            this.$parent.close();
        }
    },
    computed: {
        hasIncompleteData () {
            return this.incompleteColumns.length > 0;
        },
        hasInActivePages () {
            return this.inActivePagesColumns.length > 0;
        },
        hasPagesWithLessThenTwelveMonthData () {
            return this.pagesWithLessThenTwelveMonthDataColumns.length > 0;
        }
    }
};

function validateSocialToolsDetails (projectColumns) {
    let incompleteColumns = [];
    let inActivePagesColumns = [];
    let pagesWithLessThenTwelveMonthDataColumns = [];
    projectColumns.forEach(column => {
        let incompleColumnObj = buildIncompleteColumnObj(column);
        if (incompleColumnObj) {
            incompleteColumns.push(incompleColumnObj);
        }

        let inActivePagesColumnObj = buildInActivePagesColumnObj(column);
        if (inActivePagesColumnObj) {
            inActivePagesColumns.push(inActivePagesColumnObj);
        }

        let pagesWithLessThenTwelveMonthDataColumnObj = buildPagesWithLessThenTwelveMonthData(column);
        if (pagesWithLessThenTwelveMonthDataColumnObj) {
            pagesWithLessThenTwelveMonthDataColumns.push(pagesWithLessThenTwelveMonthDataColumnObj);
        }
    });
    return {
        incompleteColumns: incompleteColumns,
        inActivePagesColumns: inActivePagesColumns,
        pagesWithLessThenTwelveMonthDataColumns: pagesWithLessThenTwelveMonthDataColumns
    };
}

function buildIncompleteColumnObj (projectColumn) {
    let incompleteSocialNetworks = [];
    if (projectColumn.fbPageId > 0 && (!projectColumn.fbPageInfo || !projectColumn.fbPageInfo.name)) {
        // Id is defined but not verified using socialtools api, so add it to incompleteSocialNetwork array
        incompleteSocialNetworks.push('Facebook');
    }
    if (projectColumn.twPageId > 0 && (!projectColumn.twPageInfo || !projectColumn.twPageInfo.name)) {
        // Id is defined but not verified using socialtools api, so add it to incompleteSocialNetwork array
        incompleteSocialNetworks.push('Twitter');
    }
    if (projectColumn.ytPageId > 0 && (!projectColumn.ytPageInfo || !projectColumn.ytPageInfo.name)) {
        // Id is defined but not verified using socialtools api, so add it to incompleteSocialNetwork array
        incompleteSocialNetworks.push('Youtube');
    }
    if (projectColumn.igPageId > 0 && (!projectColumn.igPageInfo || !projectColumn.igPageInfo.name)) {
        // Id is defined but not verified using socialtools api, so add it to incompleteSocialNetwork array
        incompleteSocialNetworks.push('Instagram');
    }
    // If any of the social network has incomplete data then add the column to incompleColumn array
    if (incompleteSocialNetworks.length > 0) {
        return {
            name: projectColumn.name,
            socialNetworks: incompleteSocialNetworks
        };
    }
}

function buildInActivePagesColumnObj (projectColumn) {
    let inActiveSocialNetworkPages = [];
    if (projectColumn.fbPageId > 0 && projectColumn.fbPageInfo && !projectColumn.fbPageInfo.isActive) {
        inActiveSocialNetworkPages.push({
            name: projectColumn.fbPageInfo.name,
            socialNetwork: projectColumn.fbPageInfo.socialNetwork
        });
    }
    if (projectColumn.twPageId > 0 && projectColumn.twPageInfo && !projectColumn.twPageInfo.isActive) {
        inActiveSocialNetworkPages.push({
            name: projectColumn.twPageInfo.name,
            socialNetwork: projectColumn.twPageInfo.socialNetwork
        });
    }
    if (projectColumn.ytPageId > 0 && projectColumn.ytPageInfo && !projectColumn.ytPageInfo.isActive) {
        inActiveSocialNetworkPages.push({
            name: projectColumn.ytPageInfo.name,
            socialNetwork: projectColumn.ytPageInfo.socialNetwork
        });
    }
    if (projectColumn.igPageId > 0 && projectColumn.igPageInfo && !projectColumn.igPageInfo.isActive) {
        inActiveSocialNetworkPages.push({
            name: projectColumn.igPageInfo.name,
            socialNetwork: projectColumn.igPageInfo.socialNetwork
        });
    }

    if (inActiveSocialNetworkPages.length > 0) {
        return {
            name: projectColumn.name,
            socialNetworkPages: inActiveSocialNetworkPages
        };
    }
}

function buildPagesWithLessThenTwelveMonthData (projectColumn) {
    let pagesWithLessThenTwelveMonthData = [];

    let getDifferenceInMonthsFromNow = (date) => {
        let now = moment.utc();
        let endDate = moment.utc(date);
        let duration = moment.duration(now.diff(endDate));
        let months = duration.asMonths();
        return months;
    };

    if (projectColumn.fbPageId > 0 && projectColumn.fbPageInfo && projectColumn.fbPageInfo.isActive &&
        getDifferenceInMonthsFromNow(projectColumn.fbPageInfo.startDate) < 12) {
        pagesWithLessThenTwelveMonthData.push({
            name: projectColumn.fbPageInfo.name,
            socialNetwork: projectColumn.fbPageInfo.socialNetwork,
            startDate: projectColumn.fbPageInfo.startDate
        });
    }
    if (projectColumn.twPageId > 0 && projectColumn.twPageInfo && projectColumn.twPageInfo.isActive &&
        getDifferenceInMonthsFromNow(projectColumn.twPageInfo.startDate) < 12) {
        pagesWithLessThenTwelveMonthData.push({
            name: projectColumn.twPageInfo.name,
            socialNetwork: projectColumn.twPageInfo.socialNetwork,
            startDate: projectColumn.twPageInfo.startDate
        });
    }
    if (projectColumn.ytPageId > 0 && projectColumn.ytPageInfo && projectColumn.ytPageInfo.isActive &&
        getDifferenceInMonthsFromNow(projectColumn.ytPageInfo.startDate) < 12) {
        pagesWithLessThenTwelveMonthData.push({
            name: projectColumn.ytPageInfo.name,
            socialNetwork: projectColumn.ytPageInfo.socialNetwork,
            startDate: projectColumn.ytPageInfo.startDate
        });
    }
    if (projectColumn.igPageId > 0 && projectColumn.igPageInfo && projectColumn.igPageInfo.isActive &&
        getDifferenceInMonthsFromNow(projectColumn.igPageInfo.startDate) < 12) {
        pagesWithLessThenTwelveMonthData.push({
            name: projectColumn.igPageInfo.name,
            socialNetwork: projectColumn.igPageInfo.socialNetwork,
            startDate: projectColumn.igPageInfo.startDate
        });
    }

    if (pagesWithLessThenTwelveMonthData.length > 0) {
        let sortedData = _.sortBy(pagesWithLessThenTwelveMonthData, (d) => d.startDate).reverse();
        return {
            name: projectColumn.name,
            socialNetworkPages: sortedData,
            dataAvailableFrom: sortedData[0].startDate
        };
    }
}
</script>

<style scoped lang="scss">
    .warning-pannel {
        margin-bottom: 30px;

        /deep/ article {
            margin-bottom: 0.1rem
        }
    }
</style>
